// extracted by mini-css-extract-plugin
export default {"searchBar":"searchBar_searchBar__ZPkBd"};